import React, { FC } from 'react';
import { AvatarGroup, Text } from '@carnica/ui-kit';
import classNames from 'classnames/bind';

import { IOptions } from 'pages/MainPage/blocks/TariffCardBlock/types';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

// Второй вариант опций по задаче BCP-23652
export const OptionsV2: FC<IOptions> = ({ icons, title }) => {
  return (
    <div className={cx('wrapper')}>
      <Text className={cx('text')} color="secondary-invert" variant="body-small">
        {title}
      </Text>
      <AvatarGroup className={cx('options__group')} items={icons} size="s" visibleCount={7} />
    </div>
  );
};
